/**
 * @generated SignedSource<<dab97a13ed7d98ecb5ac7adde12651a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type queueFragment_Query$variables = {
  history?: number | null | undefined;
};
export type queueFragment_Query$data = {
  readonly accountQueue: {
    readonly active: ReadonlyArray<{
      readonly attempts: number;
      readonly blocker: string | null | undefined;
      readonly cancelRequestedAt: any | null | undefined;
      readonly childJobIds: ReadonlyArray<number>;
      readonly createdAt: any | null | undefined;
      readonly currentObject: string | null | undefined;
      readonly errorMessage: string | null | undefined;
      readonly etaSeconds: number | null | undefined;
      readonly finishedAt: any | null | undefined;
      readonly jobId: number;
      readonly kind: string;
      readonly label: string;
      readonly outcome: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
      readonly params: any;
      readonly parentJobId: number | null | undefined;
      readonly phase: string | null | undefined;
      readonly queuePosition: number;
      readonly requestedBy: string | null | undefined;
      readonly rowsProcessed: number;
      readonly rowsTotal: number | null | undefined;
      readonly source: string;
      readonly stageLabels: ReadonlyArray<{
        readonly key: string;
        readonly label: string;
        readonly state: string;
      }>;
      readonly stagesDone: ReadonlyArray<string>;
      readonly stagesTotal: number;
      readonly stalled: boolean;
      readonly startedAt: any | null | undefined;
      readonly status: string;
      readonly supersededByJobId: number | null | undefined;
      readonly terminal: boolean;
      readonly typicalSeconds: number | null | undefined;
      readonly unit: string | null | undefined;
    }>;
    readonly activeCount: number;
    readonly history: ReadonlyArray<{
      readonly attempts: number;
      readonly blocker: string | null | undefined;
      readonly cancelRequestedAt: any | null | undefined;
      readonly childJobIds: ReadonlyArray<number>;
      readonly createdAt: any | null | undefined;
      readonly currentObject: string | null | undefined;
      readonly errorMessage: string | null | undefined;
      readonly etaSeconds: number | null | undefined;
      readonly finishedAt: any | null | undefined;
      readonly jobId: number;
      readonly kind: string;
      readonly label: string;
      readonly outcome: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
      readonly params: any;
      readonly parentJobId: number | null | undefined;
      readonly phase: string | null | undefined;
      readonly queuePosition: number;
      readonly requestedBy: string | null | undefined;
      readonly rowsProcessed: number;
      readonly rowsTotal: number | null | undefined;
      readonly source: string;
      readonly stageLabels: ReadonlyArray<{
        readonly key: string;
        readonly label: string;
        readonly state: string;
      }>;
      readonly stagesDone: ReadonlyArray<string>;
      readonly stagesTotal: number;
      readonly stalled: boolean;
      readonly startedAt: any | null | undefined;
      readonly status: string;
      readonly supersededByJobId: number | null | undefined;
      readonly terminal: boolean;
      readonly typicalSeconds: number | null | undefined;
      readonly unit: string | null | undefined;
    }>;
    readonly queuedKinds: ReadonlyArray<string>;
    readonly running: {
      readonly currentObject: string | null | undefined;
      readonly jobId: number;
      readonly label: string;
      readonly phase: string | null | undefined;
      readonly rowsProcessed: number;
      readonly rowsTotal: number | null | undefined;
      readonly status: string;
      readonly unit: string | null | undefined;
    } | null | undefined;
    readonly schedules: ReadonlyArray<{
      readonly cadence: string;
      readonly createdBy: string | null | undefined;
      readonly due: boolean;
      readonly enabled: boolean;
      readonly everyMinutes: number;
      readonly kind: string;
      readonly label: string;
      readonly lastJobId: number | null | undefined;
      readonly lastRunAt: any | null | undefined;
      readonly nextRunAt: any;
      readonly scheduleId: number;
    }>;
    readonly startableKinds: ReadonlyArray<{
      readonly kind: string;
      readonly label: string;
      readonly params: any;
    }>;
  };
};
export type queueFragment_Query = {
  response: queueFragment_Query$data;
  variables: queueFragment_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "history"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "params",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentObject",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowsProcessed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowsTotal",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v12 = [
  (v4/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requestedBy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentJobId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "supersededByJobId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "attempts",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "finishedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cancelRequestedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "stalled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "terminal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "queuePosition",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "blocker",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "stagesTotal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "stagesDone",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountJobStage",
    "kind": "LinkedField",
    "name": "stageLabels",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountJobOutcome",
    "kind": "LinkedField",
    "name": "outcome",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "typicalSeconds",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "etaSeconds",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "childJobIds",
    "storageKey": null
  }
],
v13 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "history",
        "variableName": "history"
      }
    ],
    "concreteType": "AccountQueue",
    "kind": "LinkedField",
    "name": "accountQueue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "queuedKinds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountJobKind",
        "kind": "LinkedField",
        "name": "startableKinds",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobSchedule",
        "kind": "LinkedField",
        "name": "schedules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduleId",
            "storageKey": null
          },
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cadence",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "everyMinutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nextRunAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "due",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastRunAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastJobId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountJob",
        "kind": "LinkedField",
        "name": "running",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountJob",
        "kind": "LinkedField",
        "name": "active",
        "plural": true,
        "selections": (v12/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountJob",
        "kind": "LinkedField",
        "name": "history",
        "plural": true,
        "selections": (v12/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queueFragment_Query",
    "selections": (v13/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queueFragment_Query",
    "selections": (v13/*: any*/)
  },
  "params": {
    "cacheID": "b62027ab7b66837908113974e89d4848",
    "id": null,
    "metadata": {},
    "name": "queueFragment_Query",
    "operationKind": "query",
    "text": "query queueFragment_Query(\n  $history: Int\n) {\n  accountQueue(history: $history) {\n    activeCount\n    queuedKinds\n    startableKinds {\n      kind\n      label\n      params\n    }\n    schedules {\n      scheduleId\n      kind\n      label\n      cadence\n      everyMinutes\n      nextRunAt\n      enabled\n      due\n      lastRunAt\n      lastJobId\n      createdBy\n    }\n    running {\n      jobId\n      label\n      status\n      phase\n      currentObject\n      rowsProcessed\n      rowsTotal\n      unit\n    }\n    active {\n      jobId\n      kind\n      label\n      status\n      phase\n      currentObject\n      rowsProcessed\n      rowsTotal\n      unit\n      errorMessage\n      params\n      source\n      requestedBy\n      parentJobId\n      supersededByJobId\n      attempts\n      startedAt\n      finishedAt\n      createdAt\n      cancelRequestedAt\n      stalled\n      terminal\n      queuePosition\n      blocker\n      stagesTotal\n      stagesDone\n      stageLabels {\n        key\n        label\n        state\n      }\n      outcome {\n        key\n        value\n      }\n      typicalSeconds\n      etaSeconds\n      childJobIds\n    }\n    history {\n      jobId\n      kind\n      label\n      status\n      phase\n      currentObject\n      rowsProcessed\n      rowsTotal\n      unit\n      errorMessage\n      params\n      source\n      requestedBy\n      parentJobId\n      supersededByJobId\n      attempts\n      startedAt\n      finishedAt\n      createdAt\n      cancelRequestedAt\n      stalled\n      terminal\n      queuePosition\n      blocker\n      stagesTotal\n      stagesDone\n      stageLabels {\n        key\n        label\n        state\n      }\n      outcome {\n        key\n        value\n      }\n      typicalSeconds\n      etaSeconds\n      childJobIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "396e27fc0fad720d16bf753bef806052";

export default node;
